var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFigureinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 794,
    height: 900,
    viewBox: "0 0 794 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7175 707.346C24.3849 708.07 22.7627 707.105 22.7627 705.588V226.135C22.7627 225.402 23.1637 224.728 23.8079 224.378L413.816 12.4771C415.149 11.753 416.771 12.7178 416.771 14.2344V493.687C416.771 494.42 416.37 495.095 415.726 495.445L25.7175 707.346Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88037 695.152C1.88037 696.669 3.5025 697.634 4.83517 696.91L394.843 485.015C395.487 484.665 395.888 483.991 395.888 483.258V3.79926C395.888 2.28259 394.266 1.31782 392.934 2.04189L2.92556 213.943C2.28143 214.293 1.88037 214.967 1.88037 215.7V695.152Z",
    stroke: "url(#paint1_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.645 716.018C43.645 717.535 45.2671 718.5 46.5998 717.775L436.608 505.881C437.252 505.531 437.653 504.857 437.653 504.123V24.6652C437.653 23.1486 436.031 22.1838 434.698 22.9079L44.6902 234.809C44.0461 235.159 43.645 235.833 43.645 236.566V716.018Z",
    stroke: "url(#paint2_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5215 726.454C64.5215 727.97 66.1436 728.935 67.4763 728.211L457.491 516.31C458.135 515.96 458.536 515.286 458.536 514.553V35.1001C458.536 33.5834 456.914 32.6187 455.581 33.3427L65.5667 245.244C64.9226 245.594 64.5215 246.268 64.5215 247.001V726.454Z",
    stroke: "url(#paint3_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3586 738.647C87.0259 739.371 85.4038 738.406 85.4038 736.89V257.431C85.4038 256.698 85.8049 256.024 86.449 255.674L476.463 43.7734C477.796 43.0494 479.418 44.0142 479.418 45.5308V524.989C479.418 525.722 479.017 526.396 478.373 526.746L88.3586 738.647Z",
    stroke: "url(#paint4_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.241 749.077C107.908 749.801 106.286 748.836 106.286 747.32V267.867C106.286 267.134 106.687 266.459 107.331 266.11L497.339 54.2086C498.672 53.4845 500.294 54.4493 500.294 55.966V535.419C500.294 536.152 499.893 536.826 499.249 537.176L109.241 749.077Z",
    stroke: "url(#paint5_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.124 759.513C128.791 760.237 127.169 759.272 127.169 757.756V278.298C127.169 277.564 127.57 276.89 128.214 276.54L518.223 64.6395C519.555 63.9154 521.177 64.8802 521.177 66.3969V545.855C521.177 546.588 520.776 547.262 520.132 547.612L130.124 759.513Z",
    stroke: "url(#paint6_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.051 768.186C148.051 769.702 149.673 770.667 151.006 769.943L541.014 558.042C541.658 557.692 542.059 557.018 542.059 556.285V76.8318C542.059 75.3151 540.437 74.3504 539.105 75.0744L149.096 286.975C148.452 287.325 148.051 288 148.051 288.733V768.186Z",
    stroke: "url(#paint7_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.927 778.621C168.927 780.138 170.549 781.103 171.882 780.378L561.896 568.478C562.54 568.128 562.941 567.454 562.941 566.721V87.2627C562.941 85.7461 561.319 84.7813 559.986 85.5054L169.972 297.406C169.328 297.756 168.927 298.43 168.927 299.163V778.621Z",
    stroke: "url(#paint8_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.764 790.81C191.432 791.534 189.81 790.57 189.81 789.053V309.601C189.81 308.868 190.211 308.193 190.855 307.843L580.869 95.9424C582.202 95.2183 583.824 96.1831 583.824 97.6997V577.152C583.824 577.885 583.423 578.56 582.779 578.91L192.764 790.81Z",
    stroke: "url(#paint9_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.692 799.488C210.692 801.005 212.315 801.97 213.647 801.246L603.662 589.345C604.306 588.995 604.707 588.321 604.707 587.588V108.135C604.707 106.619 603.085 105.654 601.753 106.378L211.738 318.273C211.093 318.623 210.692 319.297 210.692 320.03V799.488Z",
    stroke: "url(#paint10_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M234.53 811.677C233.197 812.401 231.575 811.436 231.575 809.919V330.467C231.575 329.734 231.976 329.059 232.62 328.709L622.628 116.809C623.961 116.085 625.583 117.049 625.583 118.566V598.018C625.583 598.751 625.182 599.426 624.538 599.776L234.53 811.677Z",
    stroke: "url(#paint11_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M252.457 820.354C252.457 821.871 254.079 822.836 255.412 822.112L645.42 610.211C646.064 609.861 646.465 609.187 646.465 608.454V129.001C646.465 127.484 644.843 126.52 643.511 127.244L253.502 339.139C252.858 339.489 252.457 340.163 252.457 340.896V820.354Z",
    stroke: "url(#paint12_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M276.288 832.549C274.956 833.273 273.333 832.309 273.333 830.792V351.333C273.333 350.6 273.735 349.926 274.379 349.576L664.393 137.675C665.725 136.95 667.348 137.915 667.348 139.432V618.891C667.348 619.624 666.946 620.298 666.302 620.648L276.288 832.549Z",
    stroke: "url(#paint13_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M297.171 842.977C295.838 843.701 294.216 842.737 294.216 841.22V361.768C294.216 361.035 294.617 360.36 295.261 360.01L685.276 148.109C686.608 147.385 688.231 148.35 688.231 149.867V629.319C688.231 630.052 687.83 630.727 687.185 631.077L297.171 842.977Z",
    stroke: "url(#paint14_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M315.098 851.657C315.098 853.174 316.72 854.139 318.053 853.415L708.061 641.514C708.705 641.164 709.106 640.489 709.106 639.756V160.297C709.106 158.781 707.484 157.816 706.151 158.54L316.143 370.441C315.499 370.791 315.098 371.465 315.098 372.198V851.657Z",
    stroke: "url(#paint15_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M338.936 863.844C337.603 864.568 335.981 863.603 335.981 862.086V382.634C335.981 381.901 336.382 381.226 337.026 380.876L727.034 168.975C728.367 168.251 729.989 169.216 729.989 170.733V650.185C729.989 650.919 729.588 651.593 728.944 651.943L338.936 863.844Z",
    stroke: "url(#paint16_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M359.818 874.281C358.485 875.005 356.863 874.04 356.863 872.524V393.065C356.863 392.332 357.264 391.657 357.908 391.307L747.916 179.406C749.249 178.682 750.871 179.647 750.871 181.164V660.623C750.871 661.356 750.47 662.03 749.826 662.38L359.818 874.281Z",
    stroke: "url(#paint17_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M380.7 884.709C379.367 885.433 377.745 884.469 377.745 882.952V403.499C377.745 402.766 378.146 402.092 378.79 401.742L768.799 189.841C770.131 189.117 771.753 190.082 771.753 191.599V671.051C771.753 671.784 771.352 672.458 770.708 672.808L380.7 884.709Z",
    stroke: "url(#paint18_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M401.268 897.482C399.936 898.207 398.313 897.242 398.313 895.725V416.273C398.313 415.54 398.715 414.865 399.359 414.515L789.367 202.614C790.7 201.89 792.322 202.855 792.322 204.372V683.824C792.322 684.557 791.921 685.232 791.277 685.582L401.268 897.482Z",
    stroke: "url(#paint19_linear)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 518.636,
    y1: 501.562,
    x2: -29.3262,
    y2: 331.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 497.754,
    y1: 491.126,
    x2: -50.2084,
    y2: 321.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 539.519,
    y1: 511.992,
    x2: -8.44371,
    y2: 342.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 560.403,
    y1: 522.427,
    x2: 12.4334,
    y2: 352.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 581.285,
    y1: 532.862,
    x2: 33.3149,
    y2: 362.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 602.16,
    y1: 543.293,
    x2: 54.1973,
    y2: 373.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 623.043,
    y1: 553.728,
    x2: 75.0794,
    y2: 383.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 643.925,
    y1: 564.159,
    x2: 95.9624,
    y2: 394.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 664.808,
    y1: 574.594,
    x2: 116.838,
    y2: 404.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 685.691,
    y1: 585.027,
    x2: 137.721,
    y2: 415.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 706.574,
    y1: 595.462,
    x2: 158.604,
    y2: 425.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 727.448,
    y1: 605.893,
    x2: 179.486,
    y2: 435.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 748.331,
    y1: 616.328,
    x2: 200.368,
    y2: 446.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 769.214,
    y1: 626.764,
    x2: 221.244,
    y2: 456.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 790.098,
    y1: 637.194,
    x2: 242.128,
    y2: 467.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 810.971,
    y1: 647.629,
    x2: 263.008,
    y2: 477.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 831.855,
    y1: 658.06,
    x2: 283.892,
    y2: 488.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 852.736,
    y1: 668.496,
    x2: 304.773,
    y2: 498.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 873.619,
    y1: 678.926,
    x2: 325.656,
    y2: 508.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 894.187,
    y1: 691.699,
    x2: 346.225,
    y2: 521.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6F4CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#6A1C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E79"
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgFigureinline as ReactComponent };